import { render, staticRenderFns } from "./hoveContent.vue?vue&type=template&id=2c4c5e9e&scoped=true&"
import script from "./hoveContent.vue?vue&type=script&lang=js&"
export * from "./hoveContent.vue?vue&type=script&lang=js&"
import style0 from "./hoveContent.vue?vue&type=style&index=0&id=2c4c5e9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c5e9e",
  null
  
)

export default component.exports